export default __webpack_public_path__ + "static/media/preloader.c2583100.gif";